<template>
  <div class="header">
    <div class="navmenu w1400" v-if="!isMobile">
      <div class="logo">
        <img src="../../assets/images/logo.png" alt="" />
      </div>
      <div class="menu">
        <el-menu
          :default-active="activeIndex2"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="rgb(168,0,0)"
          text-color="#FEE8C4"
          active-text-color="#b50000"
          :router="true"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-submenu
            :index="'/partybuildinggarden' + index"
            @click.native="changeSubmenu(index, 0)"
            v-for="(item, index) in menuList"
            :key="index"
            :class="{ showIcon: !item.children }"
          >
            <template slot="title">{{ item.menuName }}</template>
            <div v-if="item.children && item.children.length > 0">
              <el-menu-item
                :index="
                  index === 3
                    ? '/subsidiaryCompanies?from=' + index + '&id=' + k
                    : '/publicpage?from=' + index + '&id=' + k
                "
                v-for="(j, k) in item.children"
                :key="k"
                >{{ j.menuName }}</el-menu-item
              >
            </div>
          </el-submenu>
          <el-menu-item index="/searchpage"
            ><i
              class="el-icon-search"
              style="font-size: 24px; color: #fee8c4"
            ></i
            ><span>搜索</span></el-menu-item
          >
        </el-menu>
      </div>
    </div>
    <div v-if="isMobile">
      <div class="mobile_header">
        <img src="../../assets/images/shanxijk.jpg" alt="" />
        <div class="navbar_header">
          <div class="nav_title"  @click="$router.push('/')">网站首页</div>
          <div class="nav_right">
            <i
              class="el-icon-s-fold"
              v-if="!drawer"
              @click="drawer = !drawer"
            ></i>
            <i
              class="el-icon-s-unfold"
              v-if="drawer"
              @click="drawer = !drawer"
            ></i>
          </div>
        </div>
      </div>
      <el-drawer
        title=""
        :visible.sync="drawer"
        direction="ttb"
        size="40%"
        style="width: 100vw; height: 100vh"
        :show-close="false"
        :withHeader="false"
        :modal-append-to-body="false"
      >
        
        <div
          class="menu_name"
          @click="changeSubmenu(index, 0)"
          v-for="(item, index) in menuList"
          :key="index"
        >
          {{ item.menuName }}
        </div>
      </el-drawer>
      <el-drawer
        title=""
        :visible.sync="drawer_right"
        direction="rtl"
        size="40%"
        style="width: 100vw; height: 100vh"
        :show-close="false"
        :withHeader="false"
        
      >
        <div class="menu_name" @click="goIndex">首页</div>
        <div
          class="menu_name"
          @click="changeSubmenu($route.query.from, index)"
          v-for="(item, index) in rightList"
          :key="index"
        >
          {{ item.menuName }}
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import homePage from "@/core/models/homePage";
export default {
  name: "CommunityHeader",
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "/",
      menuList: [],
      silderList: [],
      rightList: [],
      isMobile: true,
      drawer: false,
      drawer_right: false,
      title: "山西万家寨水控水资源有限公司",
      path: "",
    };
  },
  created() {
    this.HomePageData();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    changeSubmenu(from, index) {
      if (from === 2) {
        this.$router.push({
          path: `/publicpage?from=${from}&id=${index}`,
        });
      } else if (from === 5) {
        
          this.$router.push({
            path: `/informationdisclosure?from=5&id=0`,
          });
      } else {
        (this.activeIndex2 = "/publicpage?from=" + from + "&id=" + index),
          this.$router.push({
            path: `/publicpage?from=${from}&id=${index}`,
          });
      }
      this.drawer = false;
      this.drawer_right = false;
    },
    async HomePageData() {
      this.loading = true;
      const res = await homePage.getHomePageData();
      this.loading = false;
      this.menuList = res.data.menuList;
      localStorage.setItem("homepageData", JSON.stringify(res.data));
    },
    handleResize() {
      if (window.innerWidth <= 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    goIndex() {
      this.$router.push({
        path: `/`,
      });
      this.drawer = false;
      this.drawer_right = false;
    },
  },
  watch: {
    $route: {
      handler: function (to) {
        this.path = to.path;

        if (to.path === "/") {
          this.activeIndex2 = "/";
          this.$forceUpdate();
        } else if (to.path === "/partybuildinggarden") {
          this.activeIndex2 = `/publicpage?from=2&id=0`;
          this.$forceUpdate();
        } else {
          this.activeIndex2 = `/publicpage?from=${to.query.from}&id=${to.query.id}`;
        }

        setTimeout(() => {
          if (to.query.from && this.menuList.length > 0) {
            if (to.query.from == "6") {
              this.title = "联系我们";
              this.rightList = [];
            } else {
              this.title =
                this.menuList[to.query.from].children[to.query.id].menuName;
              this.rightList = this.menuList[to.query.from].children;
            }
          } else {
            this.title = "山西万家寨水控水资源有限公司";
          }
        }, 200);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.header {
  // position: relative;
  background: url("../../assets/images/header_bg.jpg") center center no-repeat;

  .navmenu {
    height: 58px;
    //width: 1420px;
    margin: 0 auto;
    display: flex;

    .logo {
      img {
        margin: 10px 0;
      }
    }
    .menu {
      margin: 0 30px;
      :deep(.el-menu-demo) {
        height: 58px;
        border: none;
        .el-menu-item {
          line-height: 58px;
          height: 58px;
          width: 120px;
          text-align: center;
          box-sizing: border-box;
          font-size: 14px;
          border-bottom: 2px solid rgb(168, 0, 0) !important;
        }
        .el-submenu {
          .el-submenu__title {
            line-height: 58px;
            font-size: 14px;
            box-sizing: border-box;
            height: 58px;
            border-bottom: 2px solid rgb(168, 0, 0) !important;
          }
        }
        .showIcon {
          .el-submenu__title {
            .el-icon-arrow-down {
              display: none;
            }
          }
        }
        .is-active {
          border-bottom: none;
          box-sizing: border-box;

          background: url("../../assets/images/nav_bg.png") no-repeat;
          background-position: 40% 65%;
          .el-submenu__title {
            // background-color: rgb(255,233,197) !important;
            background: url("../../assets/images/nav_bg.png") no-repeat;
            background-position: 40% 65%;
            line-height: 58px;
            height: 58px;
            border-bottom: none;
            box-sizing: border-box;
            font-size: 14px;
          }
        }
      }
    }
  }
  .mobile_header {
    background-color: #fff;
    width: 100%;
    height: 120px;
    text-align: center;
    position: relative;
    line-height: 45px;
    font-size: 18px;
    img {
      margin: 14px auto 0;
      width: 135px;
    }
    .navbar_header {
      width: 100%;
      height: 50px;
      background: url("../../assets/images/header_bg.jpg");
      display: flex;
      justify-content: space-between;
      padding: 0 25px;
      box-sizing: border-box;
      .nav_title{
        color: #FEE8C4;
        font-size: 18px;
      }
      .nav_right{
        color: #FEE8C4;
        font-size: 30px;
        .el-icon-s-fold{
          font-size: 30px;
        }
        .el-icon-s-unfold{
          font-size: 30px;
        }
      }
    }
  }
  :deep(.el-drawer__wrapper) {
      top: 120px;
     
    .el-drawer__container {
      
      .el-drawer {
        
        background-color: #f7f7f7;
        
        .el-drawer__body {
          background-color: #f7f7f7;
          padding-left: 15px;
          background: url('../../assets/images/header_bg.jpg');
          height: 400px;
          .menu_name {
            padding: 11px 15px 11px 0;
            box-sizing: border-box;
            border-bottom: 1px solid rgba(255, 255, 255, 0.3);
            color: #000;
            font-size: 16px;
            line-height: 20px;
            border-bottom: 1px solid #c8c7cc;
          }
        }
      }
    }
  }
}
</style>
